import { h, Fragment } from 'preact';
import { Dialog, Transition } from '@headlessui/react';
import { useEffect, useRef } from 'preact/hooks';
import Layout from './layout';

const Panel = ({
  // Alignment defaults right, but can be set to 'left'
  align = 'right',
  // Any additional classes needed for the Panel
  additionalClasses = '',
  // Children elements of panel
  children,
  // String to identify the context usage of the panel
  context = '',
  // Function to call when panel closes
  onClose = () => {},
  // Controls open/close state of panel, expected as a prop
  open = false,
}) => {
  const layout = Layout.getInstance();
  const isTabletOrMobile = layout.isBelowBreakpoint('md');
  const alignment = isTabletOrMobile ? 'left' : align;
  const scrollOffset = useRef(0);

  // @TODO update alignment to respect breakpoint size changes
  const alignClasses =
    alignment === 'left'
      ? 'left-0 lg:left-0 lg:right-[unset]'
      : 'left-0 lg:right-0 lg:left-[unset]';

  // eslint-disable-next-line max-len
  const classes = `fixed top-0 ${alignClasses} bottom-0 w-full md:w-[507px] z-50 bg-grey-200`;

  useEffect(() => {
    if (open) {
      const { scrollY } = window;
      document.body.classList.add('disabled-scroll');
      scrollOffset.current = scrollY;
      if (scrollY === 0 && document.body.style.marginTop) {
        scrollOffset.current = Math.abs(
          parseInt(document.body.style.marginTop, 10),
        );
        document.body.style.top = document.body.style.marginTop;
      } else {
        document.body.style.top = `-${scrollY}px`;
      }
    } else {
      document.body.classList.remove('disabled-scroll');
      document.body.style.top = `0`;
      if (scrollOffset.current > 0) {
        window.scrollTo(0, scrollOffset.current);
      }
    }
  }, [open]);

  return (
    <Transition show={open} as={Fragment}>
      <Dialog className={``} onClose={onClose} data-context={context}>
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/20 z-50" aria-hidden="true" />
        </Transition.Child>

        <Transition.Child
          as={Fragment}
          className={`${classes} ${additionalClasses}`}
          enter="transition ease-out duration-200 transform"
          enterFrom={`${
            alignment === 'left' ? '-translate-x-full' : 'translate-x-full'
          }`}
          enterTo="translate-x-0"
          leave="transition ease-out duration-300 transform"
          leaveFrom="translate-x-0"
          leaveTo={`${
            alignment === 'left' ? '-translate-x-full' : 'translate-x-full'
          }`}
        >
          <Dialog.Panel>{children}</Dialog.Panel>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};

export default Panel;
